"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _Text = _interopRequireDefault(require("../Text"));

var Heading = function Heading(props) {
  return /*#__PURE__*/_react["default"].createElement(_Text["default"], (0, _extends2["default"])({
    as: "p",
    textStyle: "h3",
    m: 0,
    mb: 2
  }, props));
};

Heading.propTypes = _Text["default"].propTypes;

var H1 = function H1(props) {
  return /*#__PURE__*/_react["default"].createElement(Heading, (0, _extends2["default"])({
    as: "h1",
    textStyle: "h1"
  }, props));
};

H1.propTypes = Heading.propTypes;

var H2 = function H2(props) {
  return /*#__PURE__*/_react["default"].createElement(Heading, (0, _extends2["default"])({
    as: "h2",
    textStyle: "h2"
  }, props));
};

H2.propTypes = Heading.propTypes;

var H3 = function H3(props) {
  return /*#__PURE__*/_react["default"].createElement(Heading, (0, _extends2["default"])({
    as: "h3",
    textStyle: "h3"
  }, props));
};

H3.propTypes = Heading.propTypes;

var H4 = function H4(props) {
  return /*#__PURE__*/_react["default"].createElement(Heading, (0, _extends2["default"])({
    as: "h4",
    textStyle: "h4"
  }, props));
};

H4.propTypes = Heading.propTypes;

var H5 = function H5(props) {
  return /*#__PURE__*/_react["default"].createElement(Heading, (0, _extends2["default"])({
    as: "h5",
    textStyle: "h5"
  }, props));
};

H5.propTypes = Heading.propTypes;

var H6 = function H6(props) {
  return /*#__PURE__*/_react["default"].createElement(Heading, (0, _extends2["default"])({
    as: "h6",
    textStyle: "h6"
  }, props));
};

H6.propTypes = Heading.propTypes;
Heading.h1 = H1;
Heading.h2 = H2;
Heading.h3 = H3;
Heading.h4 = H4;
Heading.h5 = H5;
Heading.h6 = H6;
var _default = Heading;
exports["default"] = _default;